import type { WalletContextType } from '@/type/wallet'
import { createContext } from 'react'

const WalletContext = createContext<WalletContextType>({
  status: 'unready',
  wallet: null,
  init: () => new Promise(() => {}),
  unInit: () => {}
})

export default WalletContext
